module.exports = __webpack_public_path__ + "static/img/Sporte_Black_Tagline.19a56b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sporte_Black_Tagline.svg
// module id = 425
// module chunks = 23